import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../theme'
import { LoginTheme, SplashTheme } from '../../themeConstants'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        top: 0,
        width: width,
    },
    splashContainer: {
        flex: 1,
        width: '100%',
        height: '100%',
        backgroundColor: LoginTheme.splashBackgroundColor,
        justifyContent: 'center',
        alignItems: 'center',
    },
    splashgif: {
        width: SplashTheme.splashGifWidth,
        height: SplashTheme.splashGifHeight,
        resizeMode: 'contain',
    },
    claimContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
        width: width / 1.8,
    },
    claimText: {
        color: LoginTheme.splashTextColor,
        fontSize: 14,
        textAlign: 'center',
    },
})

export default styles
